import moment from "moment";

const DEFAULT_DAY = 3; // Wednesday
const DEFAULT_HOUR = 15;
const DEFAULT_MINUTES = 0;

export const getUtcDate = (date) => moment(date)
    .seconds(0)
    .milliseconds(0)
    .utcOffset(0);

export const getDate = (date) => moment(date);

export const getDateString = (date) => moment(date).format('YYYY-MM-DDTHH:mm');

const getNextDayAt = (day, hours, minutes) => {
    const today = moment().isoWeekday();
    const nextDefaultDay = today <= day ?
        moment().isoWeekday(day) :
        moment().add(1, 'weeks').isoWeekday(day);
    return nextDefaultDay
        .hours(hours)
        .minutes(minutes)
        .seconds(0)
        .milliseconds(0);
}
export const getDefaultDate = () => getNextDayAt(DEFAULT_DAY, DEFAULT_HOUR, DEFAULT_MINUTES);

export const moveDate = (dateToMove) => {
    const date = getDate(dateToMove);
    return getNextDayAt(date.isoWeekday(), date.hours(), date.minutes());
}

export const formatDate = (date) => getDate(date).format('DD-MM-YYYY HH:mm:ss');
export const formatTime = (date) => getDate(date).format('h:mm:ss A');
export const formatDayOfWeek = (date) => getDate(date).format('dddd');
